<template>
    <div class="full flex wrap center">
        <div class="full excel flex wrap center vcenter">
            <button @click.prevent="view()">مشاهده حساب کاربری</button>
        </div>
        <div class="full pdf flex wrap center vcenter">
            <button @click.prevent="sso()">ورود به حساب کابری</button>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'UserAction',
    props: ['data'],
    inject: ['base'],
    components: {},
    data() {
        return {

        }
    },
    methods: {
        view() {
            window.open(`/Dashboard/Form/Account/${this.data?.extras}`)

            this.$emit('onresult')
        },
        sso() {
            this.$emit('onloading', true)
            this.base.API().post(`Authentication/Authorize/SSORequest`, {
                data: this.data?.extras
            }, (response) => {
                this.$emit('onloading', false)
                if (this.base.Util().success(response)) {
                    window.open(`https://sso.atiyehiraniancf.com/SSO?uid=${response.data.uid}&guid=${response.data.data}`)

                    this.$emit('onresult')
                }
                else
                    this.base.Notification().error({
                        code: response.data.errorCode,
                        referr: 'inquiry'
                    })
            }, (error) => {
                this.$emit('onloading', false)
                this.base.Notification().error({
                    code: 5000,
                    text: 'خطایی رخ داد، لطفا مجددا تلاش کنید!'
                })
            })
        }
    }
}
</script>

<style src="../../assets/css/components/dialogs/useraction.css"></style>